export interface ConstituencyInfo {
  no: number
  name: string
  district: string
  reserved?: 'SC' | 'ST'
}

/**
 * All 294 West Bengal Legislative Assembly constituencies (2008 delimitation),
 * each mapped to its district. This is a closed, official list (unlike the
 * free-text reference lists in Settings -> Reference Data) -- it changes only
 * on a fresh Election Commission delimitation, so it lives in code rather
 * than the user-editable store.
 * Source: https://en.wikipedia.org/wiki/List_of_constituencies_of_the_West_Bengal_Legislative_Assembly
 */
export const WB_CONSTITUENCIES: ConstituencyInfo[] = [
  { no: 1, name: 'Mekliganj', district: 'Cooch Behar', reserved: 'SC' },
  { no: 2, name: 'Mathabhanga', district: 'Cooch Behar', reserved: 'SC' },
  { no: 3, name: 'Cooch Behar Uttar', district: 'Cooch Behar', reserved: 'SC' },
  { no: 4, name: 'Cooch Behar Dakshin', district: 'Cooch Behar' },
  { no: 5, name: 'Sitalkuchi', district: 'Cooch Behar', reserved: 'SC' },
  { no: 6, name: 'Sitai', district: 'Cooch Behar', reserved: 'SC' },
  { no: 7, name: 'Dinhata', district: 'Cooch Behar' },
  { no: 8, name: 'Natabari', district: 'Cooch Behar' },
  { no: 9, name: 'Tufanganj', district: 'Cooch Behar' },
  { no: 10, name: 'Kumargram', district: 'Alipurduar', reserved: 'ST' },
  { no: 11, name: 'Kalchini', district: 'Alipurduar', reserved: 'ST' },
  { no: 12, name: 'Alipurduars', district: 'Alipurduar' },
  { no: 13, name: 'Falakata', district: 'Alipurduar', reserved: 'SC' },
  { no: 14, name: 'Madarihat', district: 'Alipurduar', reserved: 'ST' },
  { no: 15, name: 'Dhupguri', district: 'Jalpaiguri', reserved: 'SC' },
  { no: 16, name: 'Maynaguri', district: 'Jalpaiguri', reserved: 'SC' },
  { no: 17, name: 'Jalpaiguri', district: 'Jalpaiguri', reserved: 'SC' },
  { no: 18, name: 'Rajganj', district: 'Jalpaiguri', reserved: 'SC' },
  { no: 19, name: 'Dabgram-Phulbari', district: 'Jalpaiguri' },
  { no: 20, name: 'Mal', district: 'Jalpaiguri', reserved: 'ST' },
  { no: 21, name: 'Nagrakata', district: 'Alipurduar', reserved: 'ST' },
  { no: 22, name: 'Kalimpong', district: 'Kalimpong' },
  { no: 23, name: 'Darjeeling', district: 'Darjeeling' },
  { no: 24, name: 'Kurseong', district: 'Darjeeling' },
  { no: 25, name: 'Matigara-Naxalbari', district: 'Darjeeling', reserved: 'SC' },
  { no: 26, name: 'Siliguri', district: 'Darjeeling' },
  { no: 27, name: 'Phansidewa', district: 'Darjeeling', reserved: 'ST' },
  { no: 28, name: 'Chopra', district: 'Uttar Dinajpur' },
  { no: 29, name: 'Islampur', district: 'Uttar Dinajpur' },
  { no: 30, name: 'Goalpokhar', district: 'Uttar Dinajpur' },
  { no: 31, name: 'Chakulia', district: 'Uttar Dinajpur' },
  { no: 32, name: 'Karandighi', district: 'Uttar Dinajpur' },
  { no: 33, name: 'Hemtabad', district: 'Uttar Dinajpur', reserved: 'SC' },
  { no: 34, name: 'Kaliaganj', district: 'Uttar Dinajpur', reserved: 'SC' },
  { no: 35, name: 'Raiganj', district: 'Uttar Dinajpur' },
  { no: 36, name: 'Itahar', district: 'Dakshin Dinajpur' },
  { no: 37, name: 'Kushmandi', district: 'Dakshin Dinajpur', reserved: 'SC' },
  { no: 38, name: 'Kumarganj', district: 'Dakshin Dinajpur' },
  { no: 39, name: 'Balurghat', district: 'Dakshin Dinajpur' },
  { no: 40, name: 'Tapan', district: 'Dakshin Dinajpur', reserved: 'ST' },
  { no: 41, name: 'Gangarampur', district: 'Dakshin Dinajpur', reserved: 'SC' },
  { no: 42, name: 'Harirampur', district: 'Dakshin Dinajpur' },
  { no: 43, name: 'Habibpur', district: 'Malda', reserved: 'ST' },
  { no: 44, name: 'Gazole', district: 'Malda', reserved: 'SC' },
  { no: 45, name: 'Chanchal', district: 'Malda' },
  { no: 46, name: 'Harishchandrapur', district: 'Malda' },
  { no: 47, name: 'Malatipur', district: 'Malda' },
  { no: 48, name: 'Ratua', district: 'Malda' },
  { no: 49, name: 'Manikchak', district: 'Malda' },
  { no: 50, name: 'Maldaha', district: 'Malda', reserved: 'SC' },
  { no: 51, name: 'English Bazar', district: 'Malda' },
  { no: 52, name: 'Mothabari', district: 'Malda' },
  { no: 53, name: 'Sujapur', district: 'Malda' },
  { no: 54, name: 'Baisnabnagar', district: 'Malda' },
  { no: 55, name: 'Farakka', district: 'Murshidabad' },
  { no: 56, name: 'Samserganj', district: 'Murshidabad' },
  { no: 57, name: 'Suti', district: 'Murshidabad' },
  { no: 58, name: 'Jangipur', district: 'Murshidabad' },
  { no: 59, name: 'Raghunathganj', district: 'Murshidabad' },
  { no: 60, name: 'Sagardighi', district: 'Murshidabad' },
  { no: 61, name: 'Lalgola', district: 'Murshidabad' },
  { no: 62, name: 'Bhagabangola', district: 'Murshidabad' },
  { no: 63, name: 'Raninagar', district: 'Murshidabad' },
  { no: 64, name: 'Murshidabad', district: 'Murshidabad' },
  { no: 65, name: 'Nabagram', district: 'Murshidabad', reserved: 'SC' },
  { no: 66, name: 'Khargram', district: 'Murshidabad', reserved: 'SC' },
  { no: 67, name: 'Burwan', district: 'Murshidabad', reserved: 'SC' },
  { no: 68, name: 'Kandi', district: 'Murshidabad' },
  { no: 69, name: 'Bharatpur', district: 'Murshidabad' },
  { no: 70, name: 'Rejinagar', district: 'Murshidabad' },
  { no: 71, name: 'Beldanga', district: 'Murshidabad' },
  { no: 72, name: 'Baharampur', district: 'Murshidabad' },
  { no: 73, name: 'Hariharpara', district: 'Murshidabad' },
  { no: 74, name: 'Naoda', district: 'Murshidabad' },
  { no: 75, name: 'Domkal', district: 'Murshidabad' },
  { no: 76, name: 'Jalangi', district: 'Murshidabad' },
  { no: 77, name: 'Karimpur', district: 'Nadia' },
  { no: 78, name: 'Tehatta', district: 'Nadia' },
  { no: 79, name: 'Palashipara', district: 'Nadia' },
  { no: 80, name: 'Kaliganj', district: 'Nadia' },
  { no: 81, name: 'Nakashipara', district: 'Nadia' },
  { no: 82, name: 'Chapra', district: 'Nadia' },
  { no: 83, name: 'Krishnanagar Uttar', district: 'Nadia' },
  { no: 84, name: 'Nabadwip', district: 'Nadia' },
  { no: 85, name: 'Krishnanagar Dakshin', district: 'Nadia' },
  { no: 86, name: 'Santipur', district: 'Nadia' },
  { no: 87, name: 'Ranaghat Uttar Paschim', district: 'Nadia' },
  { no: 88, name: 'Krishnaganj', district: 'Nadia', reserved: 'SC' },
  { no: 89, name: 'Ranaghat Uttar Purba', district: 'Nadia', reserved: 'SC' },
  { no: 90, name: 'Ranaghat Dakshin', district: 'Nadia', reserved: 'SC' },
  { no: 91, name: 'Chakdaha', district: 'Nadia' },
  { no: 92, name: 'Kalyani', district: 'North 24 Parganas', reserved: 'SC' },
  { no: 93, name: 'Haringhata', district: 'North 24 Parganas', reserved: 'SC' },
  { no: 94, name: 'Bagda', district: 'North 24 Parganas', reserved: 'SC' },
  { no: 95, name: 'Bangaon Uttar', district: 'North 24 Parganas', reserved: 'SC' },
  { no: 96, name: 'Bangaon Dakshin', district: 'North 24 Parganas', reserved: 'SC' },
  { no: 97, name: 'Gaighata', district: 'North 24 Parganas', reserved: 'SC' },
  { no: 98, name: 'Swarupnagar', district: 'North 24 Parganas', reserved: 'SC' },
  { no: 99, name: 'Baduria', district: 'North 24 Parganas' },
  { no: 100, name: 'Habra', district: 'North 24 Parganas' },
  { no: 101, name: 'Ashoknagar', district: 'North 24 Parganas' },
  { no: 102, name: 'Amdanga', district: 'North 24 Parganas' },
  { no: 103, name: 'Bijpur', district: 'North 24 Parganas' },
  { no: 104, name: 'Naihati', district: 'North 24 Parganas' },
  { no: 105, name: 'Bhatpara', district: 'North 24 Parganas' },
  { no: 106, name: 'Jagatdal', district: 'North 24 Parganas' },
  { no: 107, name: 'Noapara', district: 'North 24 Parganas' },
  { no: 108, name: 'Barrackpur', district: 'North 24 Parganas' },
  { no: 109, name: 'Khardaha', district: 'North 24 Parganas' },
  { no: 110, name: 'Dum Dum Uttar', district: 'North 24 Parganas' },
  { no: 111, name: 'Panihati', district: 'North 24 Parganas' },
  { no: 112, name: 'Kamarhati', district: 'North 24 Parganas' },
  { no: 113, name: 'Baranagar', district: 'North 24 Parganas' },
  { no: 114, name: 'Dum Dum', district: 'North 24 Parganas' },
  { no: 115, name: 'Rajarhat New Town', district: 'North 24 Parganas' },
  { no: 116, name: 'Bidhannagar', district: 'North 24 Parganas' },
  { no: 117, name: 'Rajarhat Gopalpur', district: 'North 24 Parganas' },
  { no: 118, name: 'Madhyamgram', district: 'North 24 Parganas' },
  { no: 119, name: 'Barasat', district: 'North 24 Parganas' },
  { no: 120, name: 'Deganga', district: 'North 24 Parganas' },
  { no: 121, name: 'Haroa', district: 'North 24 Parganas' },
  { no: 122, name: 'Minakhan', district: 'North 24 Parganas', reserved: 'SC' },
  { no: 123, name: 'Sandeshkhali', district: 'North 24 Parganas', reserved: 'ST' },
  { no: 124, name: 'Basirhat Dakshin', district: 'North 24 Parganas' },
  { no: 125, name: 'Basirhat Uttar', district: 'North 24 Parganas' },
  { no: 126, name: 'Hingalganj', district: 'North 24 Parganas', reserved: 'SC' },
  { no: 127, name: 'Gosaba', district: 'South 24 Parganas', reserved: 'SC' },
  { no: 128, name: 'Basanti', district: 'South 24 Parganas', reserved: 'SC' },
  { no: 129, name: 'Kultali', district: 'South 24 Parganas', reserved: 'SC' },
  { no: 130, name: 'Patharpratima', district: 'South 24 Parganas' },
  { no: 131, name: 'Kakdwip', district: 'South 24 Parganas' },
  { no: 132, name: 'Sagar', district: 'South 24 Parganas' },
  { no: 133, name: 'Kulpi', district: 'South 24 Parganas' },
  { no: 134, name: 'Raidighi', district: 'South 24 Parganas' },
  { no: 135, name: 'Mandirbazar', district: 'South 24 Parganas', reserved: 'SC' },
  { no: 136, name: 'Jaynagar', district: 'South 24 Parganas', reserved: 'SC' },
  { no: 137, name: 'Baruipur Purba', district: 'South 24 Parganas', reserved: 'SC' },
  { no: 138, name: 'Canning Paschim', district: 'South 24 Parganas', reserved: 'SC' },
  { no: 139, name: 'Canning Purba', district: 'South 24 Parganas' },
  { no: 140, name: 'Baruipur Paschim', district: 'South 24 Parganas' },
  { no: 141, name: 'Magrahat Purba', district: 'South 24 Parganas', reserved: 'SC' },
  { no: 142, name: 'Magrahat Paschim', district: 'South 24 Parganas' },
  { no: 143, name: 'Diamond Harbour', district: 'South 24 Parganas' },
  { no: 144, name: 'Falta', district: 'South 24 Parganas' },
  { no: 145, name: 'Satgachhia', district: 'South 24 Parganas' },
  { no: 146, name: 'Bishnupur', district: 'South 24 Parganas', reserved: 'SC' },
  { no: 147, name: 'Sonarpur Dakshin', district: 'South 24 Parganas' },
  { no: 148, name: 'Bhangar', district: 'South 24 Parganas' },
  { no: 149, name: 'Kasba', district: 'Kolkata' },
  { no: 150, name: 'Jadavpur', district: 'Kolkata' },
  { no: 151, name: 'Sonarpur Uttar', district: 'Kolkata' },
  { no: 152, name: 'Tollyganj', district: 'Kolkata' },
  { no: 153, name: 'Behala Purba', district: 'Kolkata' },
  { no: 154, name: 'Behala Paschim', district: 'Kolkata' },
  { no: 155, name: 'Maheshtala', district: 'South 24 Parganas' },
  { no: 156, name: 'Budge Budge', district: 'Kolkata' },
  { no: 157, name: 'Metiaburuz', district: 'Kolkata' },
  { no: 158, name: 'Kolkata Port', district: 'Kolkata' },
  { no: 159, name: 'Bhabanipur', district: 'Kolkata' },
  { no: 160, name: 'Rashbehari', district: 'Kolkata' },
  { no: 161, name: 'Ballygunge', district: 'Kolkata' },
  { no: 162, name: 'Chowranghee', district: 'Kolkata' },
  { no: 163, name: 'Entally', district: 'Kolkata' },
  { no: 164, name: 'Beleghata', district: 'Kolkata' },
  { no: 165, name: 'Jorasanko', district: 'Kolkata' },
  { no: 166, name: 'Shyampukur', district: 'Kolkata' },
  { no: 167, name: 'Maniktola', district: 'Kolkata' },
  { no: 168, name: 'Kashipur-Belgachhia', district: 'Kolkata' },
  { no: 169, name: 'Bally', district: 'Howrah' },
  { no: 170, name: 'Howrah Uttar', district: 'Howrah' },
  { no: 171, name: 'Howrah Madhya', district: 'Howrah' },
  { no: 172, name: 'Shibpur', district: 'Howrah' },
  { no: 173, name: 'Howrah Dakshin', district: 'Howrah' },
  { no: 174, name: 'Sankrail', district: 'Howrah', reserved: 'SC' },
  { no: 175, name: 'Panchla', district: 'Howrah' },
  { no: 176, name: 'Uluberia Purba', district: 'Howrah' },
  { no: 177, name: 'Uluberia Uttar', district: 'Howrah', reserved: 'SC' },
  { no: 178, name: 'Uluberia Dakshin', district: 'Howrah' },
  { no: 179, name: 'Shyampur', district: 'Howrah' },
  { no: 180, name: 'Bagnan', district: 'Howrah' },
  { no: 181, name: 'Amta', district: 'Howrah' },
  { no: 182, name: 'Udaynarayanpur', district: 'Howrah' },
  { no: 183, name: 'Jagatballavpur', district: 'Howrah' },
  { no: 184, name: 'Domjur', district: 'Howrah' },
  { no: 185, name: 'Uttarpara', district: 'Hooghly' },
  { no: 186, name: 'Sreerampur', district: 'Hooghly' },
  { no: 187, name: 'Champdani', district: 'Hooghly' },
  { no: 188, name: 'Singur', district: 'Hooghly' },
  { no: 189, name: 'Chandannagar', district: 'Hooghly' },
  { no: 190, name: 'Chunchura', district: 'Hooghly' },
  { no: 191, name: 'Balagarh', district: 'Hooghly', reserved: 'SC' },
  { no: 192, name: 'Pandua', district: 'Hooghly' },
  { no: 193, name: 'Saptagram', district: 'Hooghly' },
  { no: 194, name: 'Chanditala', district: 'Hooghly' },
  { no: 195, name: 'Jangipara', district: 'Hooghly' },
  { no: 196, name: 'Haripal', district: 'Hooghly' },
  { no: 197, name: 'Dhanekhali', district: 'Hooghly', reserved: 'SC' },
  { no: 198, name: 'Tarakeswar', district: 'Hooghly' },
  { no: 199, name: 'Pursurah', district: 'Hooghly' },
  { no: 200, name: 'Arambag', district: 'Hooghly', reserved: 'SC' },
  { no: 201, name: 'Goghat', district: 'Hooghly', reserved: 'SC' },
  { no: 202, name: 'Khanakul', district: 'Hooghly' },
  { no: 203, name: 'Tamluk', district: 'Purba Medinipur' },
  { no: 204, name: 'Panskura Purba', district: 'Purba Medinipur' },
  { no: 205, name: 'Panskura Paschim', district: 'Purba Medinipur' },
  { no: 206, name: 'Moyna', district: 'Purba Medinipur' },
  { no: 207, name: 'Nandakumar', district: 'Purba Medinipur' },
  { no: 208, name: 'Mahisadal', district: 'Purba Medinipur' },
  { no: 209, name: 'Haldia', district: 'Purba Medinipur', reserved: 'SC' },
  { no: 210, name: 'Nandigram', district: 'Purba Medinipur' },
  { no: 211, name: 'Chandipur', district: 'Purba Medinipur' },
  { no: 212, name: 'Patashpur', district: 'Purba Medinipur' },
  { no: 213, name: 'Kanthi Uttar', district: 'Purba Medinipur' },
  { no: 214, name: 'Bhagabanpur', district: 'Purba Medinipur' },
  { no: 215, name: 'Khejuri', district: 'Purba Medinipur', reserved: 'SC' },
  { no: 216, name: 'Kanthi Dakshin', district: 'Purba Medinipur' },
  { no: 217, name: 'Ramnagar', district: 'Purba Medinipur' },
  { no: 218, name: 'Egra', district: 'Purba Medinipur' },
  { no: 219, name: 'Dantan', district: 'Paschim Medinipur' },
  { no: 220, name: 'Nayagram', district: 'Jhargram', reserved: 'ST' },
  { no: 221, name: 'Gopiballavpur', district: 'Jhargram' },
  { no: 222, name: 'Jhargram', district: 'Jhargram' },
  { no: 223, name: 'Keshiary', district: 'Paschim Medinipur', reserved: 'ST' },
  { no: 224, name: 'Kharagpur Sadar', district: 'Paschim Medinipur' },
  { no: 225, name: 'Narayangarh', district: 'Paschim Medinipur' },
  { no: 226, name: 'Sabang', district: 'Paschim Medinipur' },
  { no: 227, name: 'Pingla', district: 'Paschim Medinipur' },
  { no: 228, name: 'Kharagpur', district: 'Paschim Medinipur' },
  { no: 229, name: 'Debra', district: 'Paschim Medinipur' },
  { no: 230, name: 'Daspur', district: 'Paschim Medinipur' },
  { no: 231, name: 'Ghatal', district: 'Paschim Medinipur', reserved: 'SC' },
  { no: 232, name: 'Chandrakona', district: 'Paschim Medinipur', reserved: 'SC' },
  { no: 233, name: 'Garbeta', district: 'Paschim Medinipur' },
  { no: 234, name: 'Salboni', district: 'Paschim Medinipur' },
  { no: 235, name: 'Keshpur', district: 'Paschim Medinipur', reserved: 'SC' },
  { no: 236, name: 'Medinipur', district: 'Paschim Medinipur' },
  { no: 237, name: 'Binpur', district: 'Jhargram', reserved: 'ST' },
  { no: 238, name: 'Bandwan', district: 'Purulia', reserved: 'ST' },
  { no: 239, name: 'Balarampur', district: 'Purulia' },
  { no: 240, name: 'Baghmundi', district: 'Purulia' },
  { no: 241, name: 'Joypur', district: 'Purulia' },
  { no: 242, name: 'Purulia', district: 'Purulia' },
  { no: 243, name: 'Manbazar', district: 'Purulia', reserved: 'ST' },
  { no: 244, name: 'Kashipur', district: 'Purulia' },
  { no: 245, name: 'Para', district: 'Purulia', reserved: 'SC' },
  { no: 246, name: 'Raghunathpur', district: 'Purulia', reserved: 'SC' },
  { no: 247, name: 'Saltora', district: 'Bankura', reserved: 'SC' },
  { no: 248, name: 'Chhatna', district: 'Bankura' },
  { no: 249, name: 'Ranibandh', district: 'Bankura', reserved: 'ST' },
  { no: 250, name: 'Raipur', district: 'Bankura', reserved: 'ST' },
  { no: 251, name: 'Taldangra', district: 'Bankura' },
  { no: 252, name: 'Bankura', district: 'Bankura' },
  { no: 253, name: 'Barjora', district: 'Bankura' },
  { no: 254, name: 'Onda', district: 'Bankura' },
  { no: 255, name: 'Bishnupur', district: 'Bankura' },
  { no: 256, name: 'Katulpur', district: 'Bankura', reserved: 'SC' },
  { no: 257, name: 'Indas', district: 'Bankura', reserved: 'SC' },
  { no: 258, name: 'Sonamukhi', district: 'Bankura', reserved: 'SC' },
  { no: 259, name: 'Khandaghosh', district: 'Purba Bardhaman', reserved: 'SC' },
  { no: 260, name: 'Burdwan Dakshin', district: 'Purba Bardhaman' },
  { no: 261, name: 'Raina', district: 'Purba Bardhaman', reserved: 'SC' },
  { no: 262, name: 'Jamalpur', district: 'Purba Bardhaman', reserved: 'SC' },
  { no: 263, name: 'Manteswar', district: 'Purba Bardhaman' },
  { no: 264, name: 'Kalna', district: 'Purba Bardhaman', reserved: 'SC' },
  { no: 265, name: 'Memari', district: 'Purba Bardhaman' },
  { no: 266, name: 'Burdwan Uttar', district: 'Purba Bardhaman', reserved: 'SC' },
  { no: 267, name: 'Bhatar', district: 'Purba Bardhaman' },
  { no: 268, name: 'Purbasthali Dakshin', district: 'Purba Bardhaman' },
  { no: 269, name: 'Purbasthali Uttar', district: 'Purba Bardhaman' },
  { no: 270, name: 'Katwa', district: 'Purba Bardhaman' },
  { no: 271, name: 'Ketugram', district: 'Purba Bardhaman' },
  { no: 272, name: 'Mangalkot', district: 'Purba Bardhaman' },
  { no: 273, name: 'Ausgram', district: 'Purba Bardhaman', reserved: 'SC' },
  { no: 274, name: 'Galsi', district: 'Purba Bardhaman', reserved: 'SC' },
  { no: 275, name: 'Pandaveswar', district: 'Paschim Bardhaman' },
  { no: 276, name: 'Durgapur Purba', district: 'Paschim Bardhaman' },
  { no: 277, name: 'Durgapur Paschim', district: 'Paschim Bardhaman' },
  { no: 278, name: 'Raniganj', district: 'Paschim Bardhaman' },
  { no: 279, name: 'Jamuria', district: 'Paschim Bardhaman' },
  { no: 280, name: 'Asansol Dakshin', district: 'Paschim Bardhaman' },
  { no: 281, name: 'Asansol Uttar', district: 'Paschim Bardhaman' },
  { no: 282, name: 'Kulti', district: 'Paschim Bardhaman' },
  { no: 283, name: 'Barabani', district: 'Paschim Bardhaman' },
  { no: 284, name: 'Dubrajpur', district: 'Birbhum', reserved: 'SC' },
  { no: 285, name: 'Suri', district: 'Birbhum' },
  { no: 286, name: 'Bolpur', district: 'Birbhum' },
  { no: 287, name: 'Nanoor', district: 'Birbhum', reserved: 'SC' },
  { no: 288, name: 'Labhpur', district: 'Birbhum' },
  { no: 289, name: 'Sainthia', district: 'Birbhum', reserved: 'SC' },
  { no: 290, name: 'Mayureswar', district: 'Birbhum' },
  { no: 291, name: 'Rampurhat', district: 'Birbhum' },
  { no: 292, name: 'Hansan', district: 'Birbhum' },
  { no: 293, name: 'Nalhati', district: 'Birbhum' },
  { no: 294, name: 'Murarai', district: 'Birbhum' },
]

export const CONSTITUENCY_NAMES = WB_CONSTITUENCIES.map((c) => c.name)

/** Constituency name -> its district, for auto-filling District on pick. */
export const CONSTITUENCY_DISTRICT: Record<string, string> = Object.fromEntries(
  WB_CONSTITUENCIES.map((c) => [c.name, c.district]),
)
